import { plannerFieldFragment } from "UnitPlans/modules/UnitPlanFragments";
import client from "lib/apolloClient/client";

export const writeLeFieldFragment = ({ field_id, data }) => {
  client.writeFragment({
    id: `PlannerField:${field_id}`,
    fragment: plannerFieldFragment.resourceLibraryField,
    fragmentName: "resourceLibraryFieldItem",
    data: data,
  });
};
